<template>
    <section class="font-poppins">
        <div class="bg-gray-100 p-2 rounded">
            <div class="flex justify-between bg-white p-2 rounded">
                <div>
                    <div class="flex">
                        <img class="bg-gray-200 rounded w-6 h-6 p-1" src="../assets/analyt-icon.svg" alt="analyt">
                        <p class="ml-2">Total Orders Initiated</p>
                    </div>
                    <p class="text-blue-700 text-xl font-semibold mt-2">{{result.totalOrders}}</p>
                </div>
                
                <div class="flex align-items-center">
                    <p class="text-green-500 text-xs text-right"> <i class="fa fa-line-chart"></i></p>
                </div>
            </div>

            <div class="flex justify-between bg-white p-2 rounded mt-4">
                <div>
                    <div class="flex">
                        <img class="bg-gray-200 rounded w-6 h-6 p-1" src="../assets/analyt-icon.svg" alt="analyt">
                        <p class="ml-2">Total Cancelled Order</p>
                    </div>
                    <p class="text-blue-700 text-xl font-semibold mt-2">{{result.totalCanceledOrders}}</p>
                </div>
                
                <div class="flex align-items-center">
                    <p class="text-green-500 text-xs text-right"> <i class="fa fa-line-chart"></i></p>
                </div>
            </div>

            <div class="flex justify-between bg-white p-2 rounded mt-4">
                <div>
                    <div class="flex">
                        <img class="bg-gray-200 rounded w-6 h-6 p-1" src="../assets/analyt-icon.svg" alt="analyt">
                        <p class="ml-2">User Account Balance</p>
                    </div>
                    <p class="text-blue-700 text-xl font-semibold mt-2">{{result.balance}}</p>
                </div>
                
                <div class="flex align-items-center">
                    <p class="text-green-500 text-xs text-right"> <i class="fa fa-line-chart"></i></p>
                </div>
            </div>            
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    // props:["id"],
    data() {
        return {
            analytics: [],
            result: [],
            token : localStorage.getItem("token"),
            id : localStorage.getItem("theId")
        }
    },

    mounted() {
        this.getAnalytics();
    },

    methods: {
        getAnalytics() {
            let token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/analytics/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    Authorization: `Bearer ${token}`,

                },
            })
            .then((res) => {
                this.result = res.data.data
            }) 
            .catch((err) => {
                err;
            })
        }
    }
}
</script>